import { Notify } from "quasar";

const sounds = {
  default: new Audio(
    import.meta.env.QUASAR_MODE === "electron"
      ? "notifications/ogg/Doorbell.ogg"
      : "/notifications/ogg/Doorbell.ogg",
  ),
  warning: new Audio(
    import.meta.env.QUASAR_MODE === "electron"
      ? "notifications/ogg/Polite.ogg"
      : "/notifications/ogg/Polite.ogg",
  ),
  error: new Audio(
    import.meta.env.QUASAR_MODE === "electron"
      ? "notifications/ogg/Newsflash.ogg"
      : "/notifications/ogg/Newsflash.ogg",
  ),
};

const defaults = {
  progress: true,
  timeout: 6000,
  position: "bottom",
  classes: "notification-dismissable",
  actions: [
    {
      icon: "close",
      color: "white",
      handler: () => {},
    },
  ],
};

const changeDefault = (name, value) => {
  defaults[name] = value;
};

const success = (message, caption, options) => {
  const notSettings = Object.assign(
    {
      color: "positive",
      message: message,
      caption: caption,
      icon: "r_done",
    },
    defaults,
  );

  if (options !== undefined) {
    if (options.actions !== undefined) {
      notSettings.actions = options.actions;
      delete notSettings.classes;
    }

    if (options.timeout == false) {
      notSettings.timeout = 0;
    } else if (options.timeout !== undefined) {
      notSettings.timeout = options.timeout;
      if (options.timeout < 5000) {
        delete notSettings.classes;
        delete notSettings.actions;
      }
    }

    if (options.sound) {
      sounds.default.load();
      sounds.default.play();
    }
  }

  return Notify.create(notSettings);
};

const info = (message, caption, options) => {
  const notSettings = Object.assign(
    {
      color: "secondary",
      message: message,
      caption: caption,
      icon: "r_info",
    },
    defaults,
  );

  if (options !== undefined) {
    if (options.actions !== undefined) {
      notSettings.actions = options.actions;
      delete notSettings.classes;
    }

    if (options.timeout == false) {
      notSettings.timeout = 0;
    } else if (options.timeout !== undefined) {
      notSettings.timeout = options.timeout;
      if (options.timeout < 5000) {
        delete notSettings.classes;
        delete notSettings.actions;
      }
    }

    if (options.sound) {
      sounds.default.load();
      sounds.default.play();
    }
  }

  return Notify.create(notSettings);
};

const chatMessage = (message, caption, options) => {
  const notSettings = Object.assign(
    {
      color: "secondary",
      message: message,
      caption: caption,
      icon: "r_chat_bubble",
    },
    defaults,
  );

  if (options !== undefined) {
    if (options.actions !== undefined) {
      notSettings.actions = options.actions;
      delete notSettings.classes;
    }

    if (options.timeout == false) {
      notSettings.timeout = 0;
    } else if (options.timeout !== undefined) {
      notSettings.timeout = options.timeout;
      if (options.timeout < 5000) {
        delete notSettings.classes;
        delete notSettings.actions;
      }
    }

    if (options.sound) {
      sounds.default.load();
      sounds.default.play();
    }
  }

  return Notify.create(notSettings);
};

const warning = (message, caption, options) => {
  const notSettings = Object.assign(
    {
      color: "warning",
      textColor: "grey-10",
      message: message,
      caption: caption,
      icon: "r_warning",
    },
    defaults,
  );

  if (options !== undefined) {
    if (options.actions !== undefined) {
      notSettings.actions = options.actions;
      delete notSettings.classes;
    }

    if (options.timeout == false) {
      notSettings.timeout = 0;
    } else if (options.timeout !== undefined) {
      notSettings.timeout = options.timeout;
      if (options.timeout < 5000) {
        delete notSettings.classes;
        delete notSettings.actions;
      }
    }

    if (options.sound) {
      sounds.warning.load();
      sounds.warning.play();
    }
  }

  return Notify.create(notSettings);
};

const error = (message, caption, options) => {
  const notSettings = Object.assign(
    {
      color: "negative",
      message: message,
      caption: caption,
      icon: "r_bug_report",
    },
    defaults,
  );

  if (options !== undefined) {
    if (options.actions !== undefined) {
      notSettings.actions = options.actions;
      delete notSettings.classes;
    }

    if (options.timeout == false) {
      notSettings.timeout = 0;
    } else if (options.timeout !== undefined) {
      notSettings.timeout = options.timeout;
      if (options.timeout < 5000) {
        delete notSettings.classes;
        delete notSettings.actions;
      }
    }

    if (options.sound) {
      sounds.error.load();
      sounds.error.play();
    }
  }

  return Notify.create(notSettings);
};

const download = (message, caption) => {
  return Notify.create({
    group: false,
    timeout: 0,
    spinner: true,
    color: "secondary",
    message: message,
    caption: caption,
  });
};

export {
  changeDefault,
  success,
  info,
  chatMessage,
  warning,
  error,
  download,
  sounds,
};
